/**
 * Inline script to measure and set notification banner height CSS variable.
 * This script runs immediately after the banner is rendered in the HTML,
 * measuring its actual height and setting the CSS variable before any paints occur.
 * This prevents Cumulative Layout Shift (CLS) by measuring the real content height.
 *
 * @param storageKey - The localStorage key to check if the banner was dismissed
 */
export function NotificationBannerHeightScript({
  storageKey = "notification-banner-dismissed",
}: {
  storageKey?: string;
}) {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          (function() {
            try {
              // Check if banner was previously dismissed
              var isDismissed = localStorage.getItem('${storageKey}');

              // Find the banner element (it should be the next sibling in the DOM)
              var banner = document.querySelector('[data-notification-banner]');

              if (banner) {
                if (isDismissed) {
                  // If dismissed, hide it and set height to 0
                  banner.style.opacity = '0';
                  banner.style.transform = 'translateY(-100%)';
                  banner.style.pointerEvents = 'none';
                  document.documentElement.style.setProperty(
                    '--notification-banner-height',
                    '0px'
                  );
                } else {
                  // Measure actual banner height and set CSS variable
                  var height = banner.offsetHeight;
                  document.documentElement.style.setProperty(
                    '--notification-banner-height',
                    height + 'px'
                  );
                }
              }
            } catch (e) {
              // Fallback: if anything fails, don't break the page
              console.error('NotificationBanner height script error:', e);
            }
          })();
        `,
      }}
    />
  );
}
